import React from "react";
import useGameStore from "../store/gameStore";
import Grid from "./Grid";
import Score from "./Score";
import BottomMenu from "./BottomMenu";
import HelpMenu from "./HelpMenu";
import Leaderboard from "./Leaderboard";
import VolumeAdjust from "./VolumeAdjust";
import GameOver from "./GameOver";

export default function Game() {
  const gameStatus = useGameStore((s) => s.gameStatus);
  const leaderboardOpen = useGameStore((s) => s.leaderboardOpen);
  const helpOpen = useGameStore((s) => s.helpOpen);
  const leaderboards = useGameStore((s) => s.leaderboards);

  return (
    <div
      className="game-area"
      style={{
        height: "600px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <VolumeAdjust />
      {leaderboardOpen && leaderboards !== undefined && <Leaderboard />}
      {helpOpen && <HelpMenu />}
      <Score />
      <Grid />
      <BottomMenu />
      {gameStatus === "gameover" && <GameOver />}
    </div>
  );
}
